import { Component ,ViewChild} from '@angular/core';
import {   NavController, NavParams, AlertController, LoadingController ,MenuController } from 'ionic-angular';
import { DbservicesProvider } from '../../providers/dbservices/dbservices';
import { NgForm } from '@angular/forms';
// import { ForgotpasswordPage } from '../../pages/forgotpassword/forgotpassword';
import { HomePage } from '../../pages/home/home';
import {DashboardPage} from '../../pages/dashboard/dashboard'
// import { HomePage } from '../../pages/home/home';


//@IonicPage()
@Component({
  selector: 'page-login',
  templateUrl: 'login.html',
})
export class LoginPage {
  // @ViewChild('myTabs') tabRef;
  login: { username?: string, password?: string } = {};
  submitted = false;
  constructor(public menuCtrl: MenuController,public alertCtrl: AlertController, public loadingCtrl: LoadingController, public DBservice: DbservicesProvider, public navCtrl: NavController, public navParams: NavParams) {
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad LoginPage');
  }
  ionViewWillEnter() {
    this.menuCtrl.enable(false);
    this.menuCtrl.swipeEnable(false);
  }
  ionViewWillLeave() {
    this.menuCtrl.enable(true);
    this.menuCtrl.swipeEnable(true);
  }
  login_page(form: NgForm) {
    this.submitted = true;
    if (form.valid) {
      
      this.DBservice.getLogin(this.login).then(
        data => {
          console.log(data);
          this.DBservice.admin_Info(this.login.username)
            .then(res => {
              console.log(res)
              localStorage.AdminId = res.message[0].email;
              localStorage.AdminPwd = res.message[0].new_password;
              this.DBservice.adminemail = res.message[0].email;
              this.DBservice.adminname = res.message[0].full_name;
              localStorage.adminName = res.message[0].full_name;
              localStorage.adminphone = res.message[0].mobile_no;
              localStorage.adminfirst_name = res.message[0].first_name
              localStorage.adminlast_name = res.message[0].last_name
              localStorage.adminRefId = res.message[0].name
              localStorage.restaurant = res.message[0].restaurant
              localStorage.restaurant_name = res.message[0].restaurant_name;
              this.DBservice.restaurant_name = res.message[0].restaurant_name;
              this.navCtrl.setRoot(DashboardPage)
            }, error => {
              this.alert('Check Email/Password');
              console.log(JSON.stringify(error.json()));
            });
        },
        err => {
          console.error(err);
          this.alert('Check Email/Password');
        })

    }
  }

  alert(condition: any) {
    let alert = this.alertCtrl.create({
      title: 'Alert',
      subTitle: 'Check Email ID/Password',
      buttons: [
        {
          text: 'OK',
          handler: () => {
            let alertTransition = alert.dismiss();
            alertTransition.then(() => {
            });
            return false;
          }
        }]
    });
    alert.present();
  }

  back() {
    // this.navCtrl.popTo(this.navCtrl.getByIndex(0));
    // this.navCtrl.parent.select(0)
    // this.navCtrl.pop()
    // this.tabRef.select(2);

    // location.href = "#/home/home/landing"
    // this.navCtrl.setRoot(HomePage);
  }
}




// WEBPACK FOOTER //
// ./src/pages/login/login.ts